export default {"src":"/_next/static/media/icon_chat_new_message.783d8d9d.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};